import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import "./SubNavbar.scss";

const SubNavbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedProduct, setSelectedProduct] = useState(null);

  useEffect(() => {
    // Get selected product from localStorage or location state
    const productFromStorage = localStorage.getItem("selectedProduct");
    const productFromState = location.state?.selectedProduct;

    if (productFromState) {
      setSelectedProduct(productFromState);
      localStorage.setItem("selectedProduct", JSON.stringify(productFromState));
    } else if (productFromStorage) {
      setSelectedProduct(JSON.parse(productFromStorage));
    } else {
      // If no product is selected, redirect to products page
      navigate("/home/products");
    }
  }, [location, navigate]);

  // Determine the initial active link based on the current path
  const getInitialActive = (path) => location.pathname === path;

  const handleBackToProducts = () => {
    localStorage.removeItem("selectedProduct");
    navigate("/home/products");
  };

  if (!selectedProduct) {
    return null; // or a loading spinner
  }

  return (
    <div className="sub-navbar-container">
      <div className="product-header">
        <button className="back-btn" onClick={handleBackToProducts}>
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M19 12H5M12 19l-7-7 7-7" />
          </svg>
          Back to Products
        </button>
        <div className="selected-product-info">
          <h2>{selectedProduct.productName}</h2>
          <span className="product-code">({selectedProduct.productCode})</span>
        </div>
      </div>

      <nav className="sub-navbar">
        <NavLink
          to="/home/software-update/modules"
          className={({ isActive }) =>
            isActive || getInitialActive("/home/software-update/modules")
              ? "active"
              : ""
          }
        >
          Modules
        </NavLink>
        <NavLink
          to="/home/software-update/plans"
          className={({ isActive }) =>
            isActive || getInitialActive("/home/software-update/plans")
              ? "active"
              : ""
          }
        >
          Plans
        </NavLink>
        <NavLink
          to="/home/software-update/pricing"
          className={({ isActive }) =>
            isActive || getInitialActive("/home/software-update/pricing")
              ? "active"
              : ""
          }
        >
          Pricing
        </NavLink>

        <NavLink
          to="/home/software-update/discounts"
          className={({ isActive }) =>
            isActive || getInitialActive("/home/software-update/discounts")
              ? "active"
              : ""
          }
        >
          Discounts
        </NavLink>
      </nav>
    </div>
  );
};

export default SubNavbar;
